import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const TaxRefundIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M143.059 113.557H131.886V83.0298H143.059C152.378 83.0298 158.112 88.7431 158.112 98.2934C158.112 107.823 152.378 113.557 143.059 113.557ZM139.054 107.401H142.806C148.035 107.422 150.902 104.913 150.902 98.2934C150.902 91.6525 148.035 89.1648 142.722 89.1437H139.054V107.401Z"
                fill={color}
            />
            <path
                d="M128.976 83.0298V113.557H122.862L110.466 95.6371H110.255V113.557H103.087V83.0298H109.285L121.555 100.95H121.808V83.0298H128.976Z"
                fill={color}
            />
            <path
                d="M92.9653 83.0298H100.175V102.721C100.175 109.551 94.9892 113.958 87.3153 113.979C79.5781 113.958 74.4551 109.551 74.4551 102.721V83.0298H81.6231V102.13C81.6231 105.356 83.921 107.696 87.3153 107.696C90.6884 107.696 92.9864 105.356 92.9653 102.13V83.0298Z"
                fill={color}
            />
            <path d="M51.7705 113.557V83.0298H72.4733V88.8907H58.9385V95.3419H71.1241V101.203H58.9385V113.557H51.7705Z" fill={color} />
            <path
                d="M27.7754 113.557V83.0298H48.8999V88.8907H34.9434V95.3419H47.8036V101.203H34.9434V107.696H48.942V113.557H27.7754Z"
                fill={color}
            />
            <path
                d="M1.88672 113.557V83.0298H14.3674C21.2403 83.0298 25.4778 86.9301 25.4567 93.1493C25.4778 97.3658 23.5382 100.359 20.1651 101.899L26.553 113.557H18.6682L13.0603 103.058H9.0547V113.557H1.88672ZM9.0547 97.3236H12.8495C16.2438 97.3447 18.0358 96.0165 18.0358 93.1493C18.0358 90.2822 16.2438 88.8486 12.8495 88.8486H9.0547V97.3236Z"
                fill={color}
            />
            <path
                d="M100.904 46.0214L106.596 55.8035H106.849L112.584 46.0214H120.637L111.403 61.2849L120.932 76.5485H112.668L106.849 66.682H106.596L100.778 76.5485H92.5557L102.043 61.2849L92.7665 46.0214H100.904Z"
                fill={color}
            />
            <path
                d="M69.312 76.5485H61.5537L71.9262 46.0214H81.4554L91.7857 76.5485H84.0696L82.0035 70.013H71.3781L69.312 76.5485ZM73.1068 64.5316H80.2748L76.8173 53.5688H76.5643L73.1068 64.5316Z"
                fill={color}
            />
            <path d="M38.8145 51.8822V46.0214H64.4927V51.8822H55.2165V76.5485H48.0907V51.8822H38.8145Z" fill={color} />
        </svg>
    );
};
